import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Input } from '@alfa-bank/site-input';

import type { TIncreaseDecreaseInput, IDeps } from './models';
import { IncreaseDecreaseInput as Component } from './increase-decrease-input';
import styles from './styles/styles.css';

// Компоненту не требуется функционал стайлера
// eslint-disable-next-line styler/check-styler
export const IncreaseDecreaseInput = createWidget<IDeps, TIncreaseDecreaseInput>({
    styles,
    Input,
})(Component);
